export default {
  companyName: {
    id: 'page_meta_title_company_name',
    defaultMessage: 'Back Market',
  },
}
